import React from "react"
import { FaEdit, FaTrash } from "react-icons/fa"

export const parseDebtorTable = ({
  data,
  onStatusClick,
  onEditClick,
  onDeleteClick,
}) => {
  const columns = [
    {
      field: "CnpjBase",
      headerName: "CNPJ",
      flex: 1.5,
      renderCell: params => <div>{params.row.CnpjBase || "N/A"}</div>,
    },
    {
      field: "Classificacao",
      headerName: "Classificação",
      flex: 1,
      renderCell: params => <div>{params.row.Classificacao || "N/A"}</div>,
    },
    {
      field: "QtdeDebitos",
      headerName: "Quantidade de débitos",
      flex: 1,
      renderCell: params => <div>{params.row.QtdeDebitos || "N/A"}</div>,
    },
    {
      field: "RazaoSocial",
      headerName: "Razão Social",
      flex: 3.5,
      renderCell: params => <div>{params.row.RazaoSocial || "N/A"}</div>,
    },
    {
      field: "Valor",
      headerName: "Valor",
      flex: 1.5,
      renderCell: params => <div>{params.row.Valor || "N/A"}</div>,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{
            color: params.row.Status ? "green" : "inherit",
            cursor: "pointer",
          }}
          onClick={() => onStatusClick(params.row)}
        >
          {params.row.Status ? "Ativo" : "Inativo"}
        </div>
      ),
    },
    {
      field: "Editar",
      headerName: "Editar",
      flex: 0.5,
      renderCell: params => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => onEditClick(params.row)}
        >
          <FaEdit size={18} color="green" />
        </div>
      ),
    },
    {
      field: "Excluir",
      headerName: "Excluir",
      flex: 0.7,
      renderCell: params => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => onDeleteClick(params.row)}
        >
          <FaTrash size={16} color="red" />
        </div>
      ),
    },
  ]

  const rows = data ? data.map(company => ({ ...company, id: company.Id })) : []

  return { columns, rows }
}
